/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import Button from '@prisjakt/ui-button';

import { bool } from 'prop-types';
import ExperimentContext from './context';
import * as S from './styles';

const fromKebab = s => s.replace(/-/g, ' ');
const fromCamel = s => s.replace(/([a-z])([A-Z])/g, '$1 $2');
const unCase = s => fromCamel(fromKebab(s));

class Editor extends React.Component {
  state = {
    open: false,
    experiment: undefined,
  };

  static propTypes = {
    isFixed: bool,
  };

  static defaultProps = {
    isFixed: true,
  };

  isActive(experiment, variant) {
    const { selectedVariants } = this.props;

    if (!selectedVariants[experiment.id] && variant === 'baseline') {
      return true;
    }

    if (!selectedVariants[experiment.id]) {
      return false;
    }

    return selectedVariants[experiment.id].selectedVariant === variant;
  }

  open = () => {
    this.setState({ open: true });
  };

  close = () => {
    this.setState({ open: false });
  };

  render() {
    const { open, experiment } = this.state;

    if (!open) {
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <S.Editor open={false} isFixed={this.props.isFixed}>
          <img
            onClick={this.open}
            width="24"
            height="24"
            alt=""
            src="https://cdn.pji.nu/g/logo/icon192x192.png"
          />
        </S.Editor>
      );
    }

    return (
      <S.Editor isFixed={this.props.isFixed} open>
        <img
          onClick={this.close}
          width="24"
          height="24"
          alt=""
          src="https://cdn.pji.nu/g/logo/icon192x192.png"
        />

        {experiment && (
          <S.Menu>
            <Button
              size="small"
              onClick={() =>
                this.setState({
                  experiment: undefined,
                })
              }
            >
              {unCase(experiment.id)}
            </Button>

            {['baseline']
              .concat(Object.keys(experiment.variants))
              .map(variant => (
                <Button
                  size="small"
                  key={variant}
                  color="positive"
                  variant={
                    this.isActive(experiment, variant) ? undefined : 'outlined'
                  }
                  onClick={() => {
                    if (this.props.selectedVariant) {
                      this.props.selectedVariant(experiment, variant);
                    }
                  }}
                >
                  {unCase(variant)}
                </Button>
              ))}
          </S.Menu>
        )}
        {!experiment && (
          <S.Menu>
            {this.props.experiments.map(exp => (
              <Button
                size="small"
                key={exp.id}
                variant="outlined"
                onClick={() => {
                  this.setState({
                    experiment: exp,
                  });
                }}
              >
                {unCase(exp.id)}
              </Button>
            ))}
          </S.Menu>
        )}
      </S.Editor>
    );
  }
}

export default ({ isFixed }) => (
  <ExperimentContext.Consumer>
    {({ selectedVariants, experiments, selectedVariant, showEditor }) => {
      if (!showEditor) {
        return null;
      }

      return (
        <Editor
          selectedVariants={selectedVariants}
          experiments={experiments}
          selectedVariant={selectedVariant}
          isFixed={isFixed}
        />
      );
    }}
  </ExperimentContext.Consumer>
);
